import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  static targets = [ 
    "resourceId", "name", "address", "zip", "city", "country", "vat_id", "default_invoice_email", 
    "id", "text", "unit", "price", "default_vat_rate", 'invoiceDate', 'quantity', 'total', 'discount_amount', 'discount_rate'
  ]

  connect() {
  }

  calculateAndSetTotal() {
    if (this.hasQuantityTarget && this.hasPriceTarget) {

      const total = this.quantityTarget.value * this.priceTarget.value;
      
      if (this.hasTotalTarget) {
        this.totalTarget.value = parseFloat(total).toFixed(2);
      }

      this.calculateTotalWithDiscount();
    }
  }

  calculateTotalWithDiscount(event = null) {
    let element = null;
    let type = null;

    if (event) {
      element = event.target;
      type = element.dataset.prefillTarget;
    } else {
      type = 'discount_rate';
    }

    let total = this.quantityTarget.value * this.priceTarget.value;

    if (type == 'discount_rate' && this.hasDiscount_rateTarget && this.discount_rateTarget.value) {
      let discountAmount = total * this.discount_rateTarget.value / 100;
      this.discount_amountTarget.value = discountAmount.toFixed(2);
      this.totalTarget.value = (total - discountAmount).toFixed(2);
    }

    if (type == 'discount_amount' && this.hasDiscount_amountTarget && this.discount_amountTarget.value) {

      let discountRate = this.discount_amountTarget.value * 100 / total;
      this.discount_rateTarget.value = discountRate.toFixed(2);
      this.totalTarget.value = (total - this.discount_amountTarget.value).toFixed(2);
    }

    if (type == 'total' && this.hasTotalTarget && this.totalTarget.value) {

      const total = this.quantityTarget.value * this.priceTarget.value;
      const result = total - this.totalTarget.value
      let discountRate = result * 100 / total;
      console.log(discountRate)
      this.discount_rateTarget.value = discountRate.toFixed(2);
      let discountAmount = total - this.totalTarget.value;
      this.discount_amountTarget.value = discountAmount.toFixed(2);
    }
  }


  fillFields() {
    fetch(`${this.data.get('requestUrl')}/${this.resourceIdTarget.value}`)
    .then(response => response.json())
    .then(data => {
      for (const [key, value] of Object.entries(data)) {
        // upcase the first character 
        var keyUpCase = key.charAt(0).toUpperCase() + key.slice(1);
        // check if target exists in view and file it with the value
        if (this[`has${keyUpCase}Target`]) {
          this[`${key}Target`].value = value;
        }
      }

      this.calculateAndSetTotal();
    });
  }

}